import { render, staticRenderFns } from "./PageNotExist.vue?vue&type=template&id=544e98de&scoped=true&"
import script from "./PageNotExist.vue?vue&type=script&lang=js&"
export * from "./PageNotExist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544e98de",
  null
  
)

export default component.exports